<div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj?.SubTaskDetail || ('SubTaskDetail' | translate) }}</h2>
        <button mat-mini-fab mat-button (click)="closeDialog()" color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
        </button>
    </div>
</div>

<mat-dialog-content>
    <ag-grid-angular #agGrid style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="rowData"
        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [frameworkComponents]="frameworkComponents"
        (gridReady)="onGridReady($event)" [pagination]="true" [paginationPageSize]="10"></ag-grid-angular>
</mat-dialog-content>

<!-- Edit SubTask Dialog -->
<ng-template #editSubTaskDialog>
    <div mat-dialog-title class="mat-title">
        <div class="d-flex justify-content-between align-items-center">
            <h1 class="main-title">{{ isViewMode ? (langObj?.ViewSubTask || 'ViewSubTask') :
                (langObj?.EditSubTask || 'EditSubTask') }}</h1>
            <!-- </button> -->
        </div>
    </div>

    <!-- Form -->
    <form [formGroup]="subTaskForm" (ngSubmit)="updateSubTaskForm()">
        <div class="w-100 prevForm" style="padding: 0 15px;">
            <input type="hidden" formControlName="Id">

            <!-- WO Details - DISABLED -->
            <mat-form-field appearance="fill" class="field-fill remarks" style="margin-top:10px;">
                <mat-label>{{ langObj?.SubWODetail || 'SubWODetail' }}</mat-label>
                <textarea matInput rows="3" type="text" formControlName="subWoDetails" readonly></textarea>
            </mat-form-field>

            <!-- Target Date - DISABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22">
                <mat-label>{{ langObj?.TargetDate || 'Target Date' }}</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="targetDate" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="true"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <!-- Machine Breakdown - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22">
                <mat-label>{{ langObj?.MachineBreakdown || 'Machine Breakdown' }}</mat-label>
                <mat-select formControlName="subTaskIsMachineBreakdown">
                    <mat-option *ngFor="let sp of spareParts" [value]="sp.ID">
                        {{ sp.Name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Spare Parts - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22">
                <mat-label>{{ langObj?.SpareParts || 'Spare Parts' }}</mat-label>
                <mat-select formControlName="subTaskIsSpareParts"
                    (selectionChange)="setValidateSubTaskSparePartsCode()">
                    <mat-option *ngFor="let sp of spareParts" [value]="sp.ID">
                        {{ sp.Name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Spare Part Code - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22" *ngIf="isSparePartsYes">
                <mat-label>{{ langObj?.SparePartCode || 'Spare Part Code' }} <span
                        *ngIf="isSparePartsYes">*</span></mat-label>
                <input matInput formControlName="subTaskSparePartCode" placeholder="Enter spare part code" />
                <mat-error *ngIf="subTaskForm.get('subTaskSparePartCode')?.hasError('required')">
                    Spare Part Code is required when Spare Parts is Yes
                </mat-error>
            </mat-form-field>
             <mat-form-field appearance="fill" class="field-fill w-22 date-time">
                <mat-label>{{ langObj?.StartTime || 'Start Time' }}</mat-label>
                <input matInput readonly [ngxMatDatetimePicker]="startTimePicker" formControlName="subTaskStartTime" [max]="maxSelectableDateTime$ | async" />
                <mat-datepicker-toggle matSuffix [for]="$any(startTimePicker)"
                    [disabled]="subTaskForm.get('subTaskStartTime')?.disabled"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #startTimePicker [enableMeridian]="true" [max]="maxSelectableDateTime$ | async"></ngx-mat-datetime-picker>
            </mat-form-field>

            <!-- SP Request Time - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22 date-time" *ngIf="isSparePartsYes">
                <mat-label>{{ langObj?.SPrequestTime || 'SP Request Time' }} <span
                        *ngIf="isSparePartTimeFieldsMandatory">*</span></mat-label>
                <input matInput readonly [ngxMatDatetimePicker]="spRequestTimePicker"
                    formControlName="subTaskSPRequestTime" [max]="maxSelectableDateTime$ | async"  />
                <mat-datepicker-toggle matSuffix [for]="$any(spRequestTimePicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #spRequestTimePicker [enableMeridian]="true" [max]="maxSelectableDateTime$ | async"></ngx-mat-datetime-picker>
                <mat-error *ngIf="subTaskForm.get('subTaskSPRequestTime')?.hasError('required')">
                    SP Request Time is required when Complete Time is set
                </mat-error>
            </mat-form-field>

            <!-- SP Received Time - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22 date-time" *ngIf="isSparePartsYes">
                <mat-label>{{ langObj?.SPReceivedTime || 'SP Received Time' }} <span
                        *ngIf="isSparePartTimeFieldsMandatory">*</span></mat-label>
                <input matInput readonly [ngxMatDatetimePicker]="spReceivedTimePicker"
                    formControlName="subTaskSPReceivedTime" [max]="maxSelectableDateTime$ | async" />
                <mat-datepicker-toggle matSuffix [for]="$any(spReceivedTimePicker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #spReceivedTimePicker [enableMeridian]="true" [max]="maxSelectableDateTime$ | async"></ngx-mat-datetime-picker>
                <mat-error *ngIf="subTaskForm.get('subTaskSPReceivedTime')?.hasError('required')">
                    SP Received Time is required when Complete Time is set
                </mat-error>
            </mat-form-field>
            <!-- Start Time - DISABLED (if already set) -->
           

            <!-- Complete Time - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22 date-time">
                <mat-label>{{ langObj?.CompleteTime || 'Complete Time' }}</mat-label>
                <input matInput readonly [ngxMatDatetimePicker]="completeTimePicker"
                    formControlName="subTaskCompleteTime" [max]="maxSelectableDateTime$ | async" />
                <mat-datepicker-toggle matSuffix [for]="$any(completeTimePicker)"
                    [disabled]="!subTaskForm.get('subTaskStartTime')?.value" ></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #completeTimePicker [enableMeridian]="true" [max]="maxSelectableDateTime$ | async" ></ngx-mat-datetime-picker>
                <mat-hint *ngIf="!subTaskForm.get('subTaskStartTime')?.value" style="color: #f44336;">
                    Start Time must be set first
                </mat-hint>
            </mat-form-field>

            <!-- Responsible - DISABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22">
                <mat-label>{{ langObj?.Responsible || 'Responsible' }}</mat-label>
                <input matInput [value]="responsibleName" readonly />
            </mat-form-field>

            <!-- External Vendor - DISABLED -->
            <mat-form-field appearance="fill" class="field-fill w-22">
                <mat-label>{{ langObj?.ExternalVendor || 'External Vendor' }}</mat-label>
                <input matInput [value]="externalVendorName" readonly />
            </mat-form-field>

            <!-- Remarks - ENABLED -->
            <mat-form-field appearance="fill" class="field-fill remarks" style="margin-top:10px;">
                <mat-label>{{ langObj?.SubWORemarks || 'SubWORemarks' }}</mat-label>
                <textarea matInput rows="3" formControlName="subWoRemarks"></textarea>
            </mat-form-field>

            <!-- File Upload Section -->
            <div class="w-100 mt-3" *ngIf="!isViewMode">
                <div class="d-flex align-items-center mb-2">
                    <button mat-raised-button type="button" color="primary" (click)="openFile()"
                        style="margin-right: 10px;">
                        <i class="fa fa-upload"></i> {{ langObj?.UploadFile || 'Upload File' }}
                    </button>
                    <span class="text-muted" style="font-size: 12px;">
                        (Allowed: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG, GIF - Max 5MB)
                    </span>
                </div>
                <input type="file" class="d-none" #fileInput (change)="readFile($event)"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.bmp,.tiff,.webp">

                <!-- File Preview Section -->
                <div class="file-preview-container" *ngIf="filePreview">
                    <div class="file-item" style="position: relative; display: inline-block; margin: 10px;">
                        <div style="border: 1px solid #ddd; padding: 10px; border-radius: 8px; position: relative;">
                            <!-- Image Preview (No Download Link) -->
                            <img *ngIf="filePreview.FileType === 'image'" [src]="filePreview.ImageSrc" width="150"
                                height="150" alt="image" style="object-fit: cover;">

                            <!-- PDF Icon -->
                            <a *ngIf="filePreview.FileExtension === 'pdf' && filePreview.ImageSrc.startsWith('http')"
                                [href]="filePreview.ImageSrc" download target="_blank">
                                <img src="./assets/images/pdf-icon.png" width="150" height="150" alt="pdf">
                            </a>
                            <img *ngIf="filePreview.FileExtension === 'pdf' && !filePreview.ImageSrc.startsWith('http')"
                                src="./assets/images/pdf-icon.png" width="150" height="150" alt="pdf">

                            <!-- Word Icon -->
                            <a *ngIf="(filePreview.FileExtension === 'doc' || filePreview.FileExtension === 'docx') && filePreview.ImageSrc.startsWith('http')"
                                [href]="filePreview.ImageSrc" download target="_blank">
                                <img src="./assets/images/word-icon.png" width="150" height="150" alt="word">
                            </a>
                            <img *ngIf="(filePreview.FileExtension === 'doc' || filePreview.FileExtension === 'docx') && !filePreview.ImageSrc.startsWith('http')"
                                src="./assets/images/word-icon.png" width="150" height="150" alt="word">

                            <!-- Excel Icon -->
                            <a *ngIf="(filePreview.FileExtension === 'xls' || filePreview.FileExtension === 'xlsx') && filePreview.ImageSrc.startsWith('http')"
                                [href]="filePreview.ImageSrc" download target="_blank">
                                <img src="./assets/images/excel-icon.png" width="150" height="150" alt="excel">
                            </a>
                            <img *ngIf="(filePreview.FileExtension === 'xls' || filePreview.FileExtension === 'xlsx') && !filePreview.ImageSrc.startsWith('http')"
                                src="./assets/images/excel-icon.png" width="150" height="150" alt="excel">

                            <!-- Other File Types -->
                            <a *ngIf="filePreview.FileType !== 'image' && 
                                     filePreview.FileExtension !== 'pdf' && 
                                     filePreview.FileExtension !== 'doc' && 
                                     filePreview.FileExtension !== 'docx' && 
                                     filePreview.FileExtension !== 'xls' && 
                                     filePreview.FileExtension !== 'xlsx' &&
                                     filePreview.ImageSrc.startsWith('http')" [href]="filePreview.ImageSrc" download
                                target="_blank">
                                <img src="./assets/images/other-file-icon.png" width="150" height="150" alt="file">
                            </a>
                            <img *ngIf="filePreview.FileType !== 'image' && 
                                       filePreview.FileExtension !== 'pdf' && 
                                       filePreview.FileExtension !== 'doc' && 
                                       filePreview.FileExtension !== 'docx' && 
                                       filePreview.FileExtension !== 'xls' && 
                                       filePreview.FileExtension !== 'xlsx' &&
                                       !filePreview.ImageSrc.startsWith('http')"
                                src="./assets/images/other-file-icon.png" width="150" height="150" alt="file">

                            <!-- Delete Button -->
                            <img src="./assets/images/delete.png" (click)="removeFile()" *ngIf="!isViewMode"
                                style="position: absolute; top: 5px; right: 5px; cursor: pointer;" alt="delete"
                                width="25px" height="25px">
                        </div>
                        <div
                            style="text-align: center; margin-top: 5px; font-size: 12px; max-width: 150px; word-wrap: break-word;">
                            {{ filePreview.FileName }}
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Buttons -->
        <div class="form-buttons mt-3" style="display: flex; justify-content: flex-end;">
            <button mat-flat-button color="accent" style="margin-top: .5rem;" type="submit" *ngIf="!isViewMode">
                {{ langObj?.Update || 'Update' }}
            </button>
            <button mat-flat-button style="margin-top: .5rem; margin-left: 10px;" type="button"
                (click)="closeEditDialog()">
                {{ langObj?.Cancel || 'Cancel' }}
            </button>
        </div>
    </form>
</ng-template>